import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import {AgentCode} from '../../common/AgentCode.enum';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {RedeemCodeVo} from '../../common/shared/api/nicolas/vo/RedeemCodeVo.interface';
import type {Maybe} from '../../graphql/generated/types';

/**
 * 리딤 코드 사용
 *
 * Origin: pageNicolasApi.getUseRedeemCode
 * API: POST /api/v1/redeemcode/use
 */
export async function postStoreRedeemCodeUse(
  params: {
    code: string;
    confirmed?: Maybe<boolean>;
    agentCode: AgentCode;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & RedeemCodeVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/redeemcode/use',
    {
      method: 'POST',
      data: {
        code: params.code,
        confirmed: params.confirmed,
        agent_code: params.agentCode,
      },
    },
    options
  );

  return response.data;
}
